import { create } from "zustand";
import {
	RecycleBinStoreSlice,
	createRecycleBinStore,
} from "./recycle-bin.store";

interface RecycleBinStoreType extends RecycleBinStoreSlice {}

export const useRecycleBinStore = create<RecycleBinStoreType>((...args) => ({
	...createRecycleBinStore(...args),
}));
